import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CHECKIN_SELECT_STORE_NAME, CheckinSelectState } from './checkin-select.state';

/** Select CheckinSelect State */
export const selectCheckinSelectState = createFeatureSelector<CheckinSelectState>(CHECKIN_SELECT_STORE_NAME);

/** ViewDetailsボタンの開閉状態を取得する */
export const selectViewDetailsOpenStatus = createSelector(selectCheckinSelectState, (state) => state.model);
